(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    angular.module('ib-destination-info-module')
        .component('ibDestinationInfo', {
            controller: 'DestinationInfoController',
            controllerAs: 'destinationCrtl',
            bindings: {
                destinationData: '=',
                inTransit: '=',
                index: '@',
                states: '<',
                requiredFields: '<',
                isLast: '<',
                containerForm: '=',
                showData: '=',
                passengerData: '='
            },
            templateUrl: ['CheckinRouterConstants', function (CheckinRouterConstants) {
                return CheckinRouterConstants.templatesRoute + 'ib-destination-info-view.html';
            }]
        });

})();